import { isLeaderBoardEligible } from '../helpers';

export default ({ portletType }) => reducer => (state, action) => {
    const nextState = reducer(state, action);
    const { leaderboards = [] } = nextState;

    if (leaderboards !== state.leaderboards && leaderboards.length > 0) {
        const nextLeaderBoards = leaderboards.filter(isLeaderBoardEligible(portletType));

        return {
            ...nextState,
            leaderboards: nextLeaderBoards
        };
    }

    return nextState;
};
